module.exports = __webpack_public_path__ + "img/commentRate_2.86aa3d2b.png";